(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chromatica-event-radar"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-event-radar]');
  if (!root) return;

  const cards = [...root.querySelectorAll('[data-er-event]')];
  const search = root.querySelector('[data-er-search]');
  const when = root.querySelector('[data-er-when]');
  const continent = root.querySelector('[data-er-continent]');
  const country = root.querySelector('[data-er-country]');
  const city = root.querySelector('[data-er-city]');
  const category = root.querySelector('[data-er-category]');
  const type = root.querySelector('[data-er-type]');
  const format = root.querySelector('[data-er-format]');
  const admission = root.querySelector('[data-er-admission]');
  const count = root.querySelector('[data-er-result-count]');
  const empty = root.querySelector('[data-er-empty]');
  const list = root.querySelector('[data-er-list]');
  const board = root.querySelector('[data-er-board]');
  const applyButton = root.querySelector('[data-er-apply]');
  const promos = [...root.querySelectorAll('[data-er-promo]')];
  const stickyFilter = root.querySelector('.chr-er__filters');
  const products = [...root.querySelectorAll('[data-er-product]')];

  const syncStickyFilterHeight = () => {
    if (!stickyFilter) return;
    root.style.setProperty('--er-sticky-filter-height', stickyFilter.offsetHeight + 'px');
  };
  syncStickyFilterHeight();
  if (stickyFilter && 'ResizeObserver' in window) new ResizeObserver(syncStickyFilterHeight).observe(stickyFilter);
  window.addEventListener('resize', syncStickyFilterHeight, {passive:true});

  const uniq = values => [...new Set(values.filter(Boolean))].sort((a,b) => a.localeCompare(b));
  const addOptions = (select, values) => {
    if (!select) return;
    uniq(values).forEach(value => {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      select.appendChild(option);
    });
  };

  addOptions(continent, cards.map(card => card.dataset.continent));
  addOptions(country, cards.map(card => card.dataset.country));
  addOptions(city, cards.map(card => card.dataset.city));
  addOptions(category, cards.flatMap(card => (card.dataset.categories || '').split('|')).filter(Boolean));
  addOptions(type, cards.map(card => card.dataset.type));
  addOptions(format, cards.map(card => card.dataset.format));
  addOptions(admission, cards.map(card => card.dataset.admission));

  const now = new Date();
  now.setHours(0,0,0,0);
  const dayMs = 86400000;
  const todayKey = [
    now.getFullYear(),
    String(now.getMonth()+1).padStart(2,'0'),
    String(now.getDate()).padStart(2,'0')
  ].join('-');

  const dayDiff = value => {
    if (!value) return null;
    return Math.round((new Date(value + 'T00:00:00') - now) / dayMs);
  };

  const cardLabel = card => {
    const start = dayDiff(card.dataset.start);
    const end = dayDiff(card.dataset.end);
    if (start !== null && start > 1) return 'IN ' + start + ' DAYS';
    if (start === 1) return 'TOMORROW';
    if (start === 0 && (end === null || end > 0)) return 'STARTS TODAY';
    if (start === 0 && end === 0) return 'TODAY';
    if (start < 0 && end === null) return 'LIVE NOW';
    if (start < 0 && end === 0) return 'ENDS TODAY';
    if (start < 0 && end === 1) return 'ENDS TOMORROW';
    if (start < 0 && end > 1) return 'LIVE NOW · ' + end + ' DAYS LEFT';
    return 'LIVE NOW';
  };

  cards.forEach(card => {
    const target = card.querySelector('[data-er-days]');
    if (target) target.textContent = cardLabel(card);
  });

  const sortKey = card => {
    const start = card.dataset.start || '9999-12-31';
    const end = card.dataset.end || start;
    return start >= todayKey ? start : end;
  };

  const sortedCards = cards.sort((a,b) => sortKey(a).localeCompare(sortKey(b)));
  sortedCards.forEach((card,index) => {
    list?.appendChild(card);
    if ((index + 1) % 5 === 0) {
      const promo = promos[Math.floor(index / 5)];
      if (promo) list?.appendChild(promo);
    }
  });

  const matchesWhen = (card, mode) => {
    if (!mode || mode === 'all') return true;
    const start = new Date((card.dataset.start || '2999-12-31') + 'T00:00:00');
    const end = new Date((card.dataset.end || card.dataset.start || '2999-12-31') + 'T23:59:59');
    if (mode === 'today') return start <= now && end >= now;
    if (mode === '7' || mode === '30') {
      const limit = new Date(now);
      limit.setDate(limit.getDate() + Number(mode));
      return end >= now && start <= limit;
    }
    if (mode === 'month') {
      const monthStart = new Date(now.getFullYear(),now.getMonth(),1);
      const monthEnd = new Date(now.getFullYear(),now.getMonth()+1,0,23,59,59);
      return end >= monthStart && start <= monthEnd;
    }
    return true;
  };

  const applyFilters = () => {
    const q = (search?.value || '').trim().toLowerCase();
    let visible = 0;
    cards.forEach(card => {
      const cats = (card.dataset.categories || '').split('|');
      const show =
        (!q || (card.dataset.search || '').includes(q)) &&
        matchesWhen(card, when?.value || 'all') &&
        (!continent?.value || card.dataset.continent === continent.value) &&
        (!country?.value || card.dataset.country === country.value) &&
        (!city?.value || card.dataset.city === city.value) &&
        (!category?.value || cats.includes(category.value)) &&
        (!type?.value || card.dataset.type === type.value) &&
        (!format?.value || card.dataset.format === format.value) &&
        (!admission?.value || card.dataset.admission === admission.value);
      card.hidden = !show;
      if (show) visible += 1;
    });
    if (count) count.textContent = visible;
    if (empty) empty.hidden = visible !== 0;
    const narrowed =
      Boolean(q) ||
      (when?.value && when.value !== 'all') ||
      Boolean(continent?.value) ||
      Boolean(country?.value) ||
      Boolean(city?.value) ||
      Boolean(category?.value) ||
      Boolean(type?.value) ||
      Boolean(format?.value) ||
      Boolean(admission?.value);
    promos.forEach(promo => { promo.hidden = narrowed; });
    const radarMapState = {
      radar: 'events',
      visibleHandles: cards.filter(card => !card.hidden).map(card => card.dataset.handle).filter(Boolean),
      shared: {
        continent: continent?.value || '',
        country: country?.value || '',
        category: category?.value || '',
        city: city?.value || ''
      }
    };
    window.ChromaticaRadarFilterState = window.ChromaticaRadarFilterState || {};
    window.ChromaticaRadarFilterState.events = radarMapState;
    window.dispatchEvent(new CustomEvent('chromatica:radar-filter', { detail: radarMapState }));
  };

  [search,when,continent,country,city,category,type,format,admission].forEach(control => {
    if (!control) return;
    control.addEventListener(control.tagName === 'INPUT' ? 'input' : 'change', applyFilters);
  });

  const scrollToResults = () => root.querySelector('#event-list')?.scrollIntoView({behavior:'smooth',block:'start'});
  applyButton?.addEventListener('click', () => { applyFilters(); scrollToResults(); });
  search?.addEventListener('keydown', event => {
    if (event.key !== 'Enter') return;
    event.preventDefault();
    applyFilters();
    scrollToResults();
  });

  const reset = () => {
    if (search) search.value = '';
    [continent,country,city,category,type,format,admission].forEach(select => { if (select) select.value = ''; });
    if (when) when.value = 'all';
    applyFilters();
  };
  root.querySelectorAll('[data-er-reset],[data-er-reset-secondary]').forEach(button => button.addEventListener('click', reset));
  root.querySelectorAll('[data-er-show-all]').forEach(link => link.addEventListener('click', event => {
    event.preventDefault();
    reset();
    scrollToResults();
  }));
  root.querySelectorAll('[data-er-show-seven]').forEach(link => link.addEventListener('click', event => {
    event.preventDefault();
    reset();
    if (when) when.value = '7';
    applyFilters();
    scrollToResults();
  }));

  if (board) {
    const top = sortedCards.slice(0,5);
    board.innerHTML = top.map(card => {
      const start = card.dataset.start;
      const startDate = new Date(start + 'T12:00:00');
      const isLive = start < todayKey;
      const display = isLive ? 'LIVE NOW' : new Intl.DateTimeFormat('en-GB',{day:'2-digit',month:'short',year:'numeric'}).format(startDate).toUpperCase();
      const title = card.querySelector('h3')?.textContent?.trim() || '';
      const href = '#' + card.id;
      return '<div class="chr-er-board-row">' +
        '<span>' + display + '</span>' +
        '<b>' + (card.dataset.city || 'Worldwide') + ' / ' + (card.dataset.country || 'Worldwide') + '</b>' +
        '<b>' + title + '</b>' +
        '<span>' + (card.dataset.type || 'EVENT') + '</span>' +
        '<a href="' + href + '" data-er-jump>OPEN</a>' +
      '</div>';
    }).join('');

    [...board.children].forEach((row,rowIndex) => {
      row.style.setProperty('--er-row-delay',(rowIndex * 190) + 'ms');
      [...row.children].forEach((cell,cellIndex) => cell.style.setProperty('--er-cell-delay',(cellIndex * 58) + 'ms'));
      requestAnimationFrame(() => row.classList.add('is-flipping'));
    });

    board.querySelectorAll('[data-er-jump]').forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      reset();
      const target = root.querySelector(link.getAttribute('href'));
      target?.scrollIntoView({behavior:'smooth',block:'start'});
      setTimeout(() => target?.focus({preventScroll:true}),500);
    }));
  }

  const clock = root.querySelector('[data-er-clock]');
  const tick = () => {
    if (!clock) return;
    clock.textContent = new Intl.DateTimeFormat('de-DE',{hour:'2-digit',minute:'2-digit',hour12:false,timeZone:'Europe/Berlin'}).format(new Date()) + ' / BERLIN';
  };
  tick();
  setInterval(tick,30000);

  root.querySelector('[data-er-shuffle]')?.addEventListener('click', () => {
    if (products.length <= 3) return;
    products.forEach(product => product.classList.remove('is-visible'));
    [...products].sort(() => Math.random() - .5).slice(0,3).forEach(product => product.classList.add('is-visible'));
  });

  const compactDate = value => String(value || '').replaceAll('-','');
  const nextDate = value => {
    const date = new Date(value + 'T00:00:00');
    date.setDate(date.getDate() + 1);
    return date.toISOString().slice(0,10).replaceAll('-','');
  };

  root.querySelectorAll('[data-er-calendar]').forEach(calendar => {
    const card = calendar.closest('[data-er-event]');
    if (!card) return;
    const start = compactDate(card.dataset.start);
    const end = nextDate(card.dataset.end || card.dataset.start);
    const title = card.dataset.calTitle || 'Chromatica Urban Event';
    const location = card.dataset.calLocation || '';
    const description = card.dataset.calDescription || '';
    const google = 'https://calendar.google.com/calendar/render?action=TEMPLATE&text=' + encodeURIComponent(title) + '&dates=' + start + '/' + end + '&details=' + encodeURIComponent(description) + '&location=' + encodeURIComponent(location);
    const googleLink = calendar.querySelector('[data-er-cal-google]');
    if (googleLink) {
      googleLink.href = google;
      googleLink.target = '_blank';
      googleLink.rel = 'noopener';
    }
    const ics = [
      'BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//Chromatica//Urban Event Radar//EN','BEGIN:VEVENT',
      'DTSTART;VALUE=DATE:' + start,'DTEND;VALUE=DATE:' + end,
      'SUMMARY:' + title.replaceAll(',','\\,'),
      'LOCATION:' + location.replaceAll(',','\\,'),
      'DESCRIPTION:' + description.replaceAll('\\n',' ').replaceAll(',','\\,'),
      'END:VEVENT','END:VCALENDAR'
    ].join('\\r\\n');
    const icsLink = calendar.querySelector('[data-er-cal-ics]');
    if (icsLink) {
      icsLink.href = 'data:text/calendar;charset=utf-8,' + encodeURIComponent(ics);
      icsLink.download = 'chromatica-event.ics';
    }
  });

  const params = new URLSearchParams(window.location.search);
  const requested = params.get('event') || window.location.hash.replace(/^#event-/,'');
  if (requested) {
    const target = cards.find(card => card.dataset.handle === requested);
    if (target) {
      reset();
      setTimeout(() => target.scrollIntoView({behavior:'smooth',block:'start'}),120);
    }
  }

  applyFilters();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chromatica-field-guide-article"]) return;
  try {
    
(() => {
  function placeFieldGuideModules(root) {
    if (!root || root.dataset.fgInlineReady === '1') return;
    const body = root.querySelector('[data-txa-article-body]');
    const source = root.querySelector('[data-fg-article-bridges]');
    if (!body || !source) return;
    // Only editorial H2 points count; nested H3 headings and promotional headings do not.
    const headings = Array.from(body.children).filter(node => node.tagName === 'H2');
    const sectionCount = headings.length;
    if (sectionCount < 2) return;

    const indices = sectionCount >= 9
      ? [2, 5, 8] // before editorial points 3, 6, 9
      : [1, 2, 3].map(fraction =>
          Math.max(1, Math.min(sectionCount - 1, Math.round(sectionCount * fraction / 4))));
    const slots = ['events', 'product', 'calls'];
    slots.forEach((key, index) => {
      const element = source.querySelector('[data-fg-bridge-slot="' + key + '"]');
      if (!element) return;
      const nativeRadar = element.querySelector('.chr-radar-embed');
      const productBox = element.querySelector('.chr-fg-bridge--product');
      if (!nativeRadar && !productBox) return;
      headings[indices[index]].insertAdjacentElement('beforebegin', element);
      element.hidden = false;
    });
    source.remove();
    root.dataset.fgInlineReady = '1';
  }

  const apply = node => {
    if (node.matches && node.matches('.chr-fga')) placeFieldGuideModules(node);
    node.querySelectorAll('.chr-fga').forEach(placeFieldGuideModules);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => apply(document), { once: true });
  } else {
    apply(document);
  }
  document.addEventListener('shopify:section:load', event => apply(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chromatica-field-guide"]) return;
  try {
    
const chrFgInit = root => {
  if (!root || root.dataset.fgTerminalReady === 'true') return;
  root.dataset.fgTerminalReady = 'true';

  const cards = [...root.querySelectorAll('[data-fg-card]')];
  const filter = root.querySelector('[data-fg-filter]');
  const search = root.querySelector('[data-fg-search]');
  const category = root.querySelector('[data-fg-category]');
  const family = root.querySelector('[data-fg-family]');
  const topic = root.querySelector('[data-fg-topic]');
  const updated = root.querySelector('[data-fg-updated]');
  const applyButton = root.querySelector('[data-fg-apply]');
  const resetButton = root.querySelector('[data-fg-reset]');
  const promos = [...root.querySelectorAll('[data-fg-promo]')];
  const toTop = root.querySelector('[data-fg-to-top]');
  const visibleCount = root.querySelector('[data-fg-visible-count]');
  const empty = root.querySelector('[data-fg-empty]');
  const grid = root.querySelector('.chr-fg-grid:not(.chr-fg-grid--preview)');

  const syncStickyFilterHeight = () => {
    if (!filter) return;
    root.style.setProperty('--fg-sticky-filter-height', filter.offsetHeight + 'px');
  };
  syncStickyFilterHeight();
  if (filter && 'ResizeObserver' in window) {
    new ResizeObserver(syncStickyFilterHeight).observe(filter);
  }
  window.addEventListener('resize', syncStickyFilterHeight, {passive:true});

  const normalize = value => String(value || '').trim().toLowerCase();

  const appendOptions = (select, values) => {
    if (!select) return;
    [...new Set(values.filter(Boolean))]
      .sort((a,b) => a.localeCompare(b, undefined, {sensitivity:'base'}))
      .forEach(value => select.add(new Option(value, value)));
  };

  if (cards.length) {
    appendOptions(category, cards.map(card => card.dataset.category || ''));
    appendOptions(family, cards.map(card => card.dataset.family || ''));

    const categoryNames = new Set(cards.map(card => normalize(card.dataset.category)));
    const ignored = new Set(['field guide','product guide','material guide','practice guide','setup guide','care guide','collection guide']);
    const topics = [];
    cards.forEach(card => {
      String(card.dataset.topics || '')
        .split('||')
        .map(value => value.trim())
        .filter(Boolean)
        .forEach(value => {
          const key = normalize(value);
          if (!ignored.has(key) && !categoryNames.has(key)) topics.push(value);
        });
    });
    appendOptions(topic, topics);
  }

  const applyFilters = () => {
    const term = normalize(search?.value);
    const categoryValue = normalize(category?.value);
    const familyValue = normalize(family?.value);
    const topicValue = normalize(topic?.value);
    const days = Number(updated?.value || 0);
    const cutoff = days ? Date.now() - (days * 86400000) : 0;
    let visible = 0;

    cards.forEach(card => {
      const haystack = normalize([
        card.dataset.title,
        card.dataset.category,
        card.dataset.family,
        card.dataset.topics
      ].join(' '));

      const topicValues = String(card.dataset.topics || '').split('||').map(normalize);
      const updatedMs = Number(card.dataset.updated || 0) * 1000;

      const match =
        (!term || haystack.includes(term)) &&
        (!categoryValue || normalize(card.dataset.category) === categoryValue) &&
        (!familyValue || normalize(card.dataset.family) === familyValue) &&
        (!topicValue || topicValues.includes(topicValue)) &&
        (!days || updatedMs >= cutoff);

      card.hidden = !match;
      if (match) visible += 1;
    });

    if (visibleCount) visibleCount.textContent = String(visible);
    if (empty) empty.hidden = visible !== 0;
    const narrowed =
      Boolean(term) ||
      Boolean(categoryValue) ||
      Boolean(familyValue) ||
      Boolean(topicValue) ||
      Boolean(days);
    promos.forEach(promo => { promo.hidden = narrowed; });
  };

  const scrollToResults = () => {
    (grid || filter)?.scrollIntoView({behavior:'smooth', block:'start'});
  };

  const reset = () => {
    if (search) search.value = '';
    if (category) category.value = '';
    if (family) family.value = '';
    if (topic) topic.value = '';
    if (updated) updated.value = '';
    applyFilters();
  };

  [search, category, family, topic, updated].forEach(control => {
    if (!control) return;
    control.addEventListener(control.tagName === 'INPUT' ? 'input' : 'change', applyFilters);
  });

  applyButton?.addEventListener('click', () => {
    applyFilters();
    scrollToResults();
  });

  search?.addEventListener('keydown', event => {
    if (event.key !== 'Enter') return;
    event.preventDefault();
    applyFilters();
    scrollToResults();
  });

  resetButton?.addEventListener('click', reset);

  root.querySelectorAll('[data-fg-show-all]').forEach(link => {
    link.addEventListener('click', event => {
      event.preventDefault();
      reset();
      scrollToResults();
    });
  });

  root.querySelectorAll('[data-fg-show-recent]').forEach(link => {
    link.addEventListener('click', event => {
      event.preventDefault();
      reset();
      if (updated) updated.value = '30';
      applyFilters();
      scrollToResults();
    });
  });

  root.querySelectorAll('[data-fg-focus-category]').forEach(link => {
    link.addEventListener('click', event => {
      event.preventDefault();
      filter?.scrollIntoView({behavior:'smooth', block:'center'});
      window.setTimeout(() => category?.focus({preventScroll:true}), 400);
    });
  });

  root.querySelectorAll('[data-fg-focus-family]').forEach(link => {
    link.addEventListener('click', event => {
      event.preventDefault();
      filter?.scrollIntoView({behavior:'smooth', block:'center'});
      window.setTimeout(() => family?.focus({preventScroll:true}), 400);
    });
  });

  const syncToTop = () => {
    if (!toTop) return;
    toTop.classList.toggle('is-visible', root.getBoundingClientRect().top < -700);
  };
  syncToTop();
  window.addEventListener('scroll', syncToTop, {passive:true});
  toTop?.addEventListener('click', () => window.scrollTo({top:0,behavior:'smooth'}));

  const terminalRows = [...root.querySelectorAll('[data-fg-terminal-row]')];
  terminalRows.forEach((row,rowIndex) => {
    row.style.setProperty('--fg-row-delay', (rowIndex * 190) + 'ms');
    [...row.children].forEach((cell,cellIndex) => {
      cell.style.setProperty('--fg-cell-delay', (cellIndex * 58) + 'ms');
    });
  });
  requestAnimationFrame(() => terminalRows.forEach(row => row.classList.add('is-flipping')));

  applyFilters();
};

document.querySelectorAll('[data-fg-root]').forEach(chrFgInit);
document.addEventListener('shopify:section:load', event => {
  const root = event.target.querySelector?.('[data-fg-root]') || (event.target.matches?.('[data-fg-root]') ? event.target : null);
  chrFgInit(root);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chromatica-open-calls"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-open-call-radar]');
  if (!root) return;

  const cards = [...root.querySelectorAll('[data-oc-call]')];
  const search = root.querySelector('[data-oc-search]');
  const deadline = root.querySelector('[data-oc-deadline]');
  const continent = root.querySelector('[data-oc-continent]');
  const country = root.querySelector('[data-oc-country]');
  const category = root.querySelector('[data-oc-category]');
  const format = root.querySelector('[data-oc-format]');
  const count = root.querySelector('[data-oc-result-count]');
  const empty = root.querySelector('[data-oc-empty]');
  const list = root.querySelector('[data-oc-list]');
  const board = root.querySelector('[data-oc-board]');
  const compactDate = value => String(value || '').replaceAll('-', '');
  const nextDate = value => {
    const date = new Date(value + 'T00:00:00');
    date.setDate(date.getDate() + 1);
    return date.toISOString().slice(0,10).replaceAll('-', '');
  };
  const applyButton = root.querySelector('[data-oc-apply]');
  const promos = [...root.querySelectorAll('[data-oc-promo]')];
  const toTop = root.querySelector('[data-oc-to-top]');
  const stickyFilter = root.querySelector('.chr-oc__filters');

  const syncStickyFilterHeight = () => {
    if (!stickyFilter) return;
    root.style.setProperty('--oc-sticky-filter-height', stickyFilter.offsetHeight + 'px');
  };
  syncStickyFilterHeight();
  if (stickyFilter && 'ResizeObserver' in window) {
    new ResizeObserver(syncStickyFilterHeight).observe(stickyFilter);
  }
  window.addEventListener('resize', syncStickyFilterHeight, {passive:true});

  const uniq = values => [...new Set(values.filter(Boolean))].sort((a,b) => a.localeCompare(b));
  const addOptions = (select, values) => {
    if (!select) return;
    uniq(values).forEach(value => {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      select.appendChild(option);
    });
  };

  addOptions(continent, cards.map(card => card.dataset.continent));
  addOptions(country, cards.map(card => card.dataset.country));
  addOptions(category, cards.flatMap(card => (card.dataset.categories || '').split('|')).filter(Boolean));

  const now = new Date();
  now.setHours(0,0,0,0);
  const dayMs = 86400000;

  cards.forEach(card => {
    const end = new Date(card.dataset.deadline + 'T23:59:59');
    const days = Math.max(0, Math.ceil((end - now) / dayMs));
    const target = card.querySelector('[data-oc-days]');
    if (target) target.textContent = days + (days === 1 ? ' DAY LEFT' : ' DAYS LEFT');
  });

  const sortedCards = cards.sort((a,b) => String(a.dataset.deadline).localeCompare(String(b.dataset.deadline)));
  sortedCards.forEach((card,index) => {
    if (!card.id) card.id = 'open-call-' + String(index + 1).padStart(3,'0');
    card.setAttribute('tabindex','-1');
    list.appendChild(card);
    if ((index + 1) % 5 === 0) {
      const promo = promos[Math.floor(index / 5)];
      if (promo) list.appendChild(promo);
    }
  });

  const matchesDeadline = (card, mode) => {
    if (!mode || mode === 'all') return true;
    const end = new Date(card.dataset.deadline + 'T23:59:59');
    const days = Math.ceil((end - now) / dayMs);
    if (mode === '7') return days >= 0 && days <= 7;
    if (mode === '30') return days >= 0 && days <= 30;
    if (mode === 'month') return end.getMonth() === now.getMonth() && end.getFullYear() === now.getFullYear();
    return true;
  };

  const applyFilters = () => {
    const q = (search?.value || '').trim().toLowerCase();
    let visible = 0;
    cards.forEach(card => {
      const cats = (card.dataset.categories || '').split('|');
      const show =
        (!q || (card.dataset.search || '').includes(q)) &&
        (!continent?.value || card.dataset.continent === continent.value) &&
        (!country?.value || card.dataset.country === country.value) &&
        (!category?.value || cats.includes(category.value)) &&
        (!format?.value || card.dataset.format === format.value) &&
        matchesDeadline(card, deadline?.value || 'all');
      card.hidden = !show;
      if (show) visible += 1;
    });
    if (count) count.textContent = visible;
    if (empty) empty.hidden = visible !== 0;
    const narrowed =
      Boolean(q) ||
      Boolean(continent?.value) ||
      Boolean(country?.value) ||
      Boolean(category?.value) ||
      Boolean(format?.value) ||
      (deadline?.value && deadline.value !== 'all');
    promos.forEach(promo => { promo.hidden = narrowed; });
    const radarMapState = {
      radar: 'open_calls',
      visibleHandles: cards.filter(card => !card.hidden).map(card => card.dataset.handle).filter(Boolean),
      shared: {
        continent: continent?.value || '',
        country: country?.value || '',
        category: category?.value || '',
        city: ''
      }
    };
    window.ChromaticaRadarFilterState = window.ChromaticaRadarFilterState || {};
    window.ChromaticaRadarFilterState.open_calls = radarMapState;
    window.dispatchEvent(new CustomEvent('chromatica:radar-filter', { detail: radarMapState }));
  };

  [search, deadline, continent, country, category, format].forEach(control => {
    if (!control) return;
    control.addEventListener(control.tagName === 'INPUT' ? 'input' : 'change', applyFilters);
  });

  const scrollToResults = () => {
    root.querySelector('#open-call-list')?.scrollIntoView({behavior:'smooth',block:'start'});
  };

  applyButton?.addEventListener('click', () => {
    applyFilters();
    scrollToResults();
  });

  search?.addEventListener('keydown', event => {
    if (event.key !== 'Enter') return;
    event.preventDefault();
    applyFilters();
    scrollToResults();
  });

  applyFilters();

  const reset = () => {
    if (search) search.value = '';
    [continent,country,category,format].forEach(select => { if (select) select.value = ''; });
    if (deadline) deadline.value = 'all';
    applyFilters();
  };
  root.querySelectorAll('[data-oc-reset],[data-oc-reset-secondary]').forEach(button => button.addEventListener('click', reset));

  root.querySelectorAll('[data-oc-show-all]').forEach(link => {
    link.addEventListener('click', event => {
      event.preventDefault();
      reset();
      scrollToResults();
    });
  });

  root.querySelectorAll('[data-oc-show-seven]').forEach(link => {
    link.addEventListener('click', event => {
      event.preventDefault();
      reset();
      if (deadline) deadline.value = '7';
      applyFilters();
      scrollToResults();
    });
  });

  if (board) {
    const top = cards.slice(0,5);
    board.innerHTML = top.map(card => {
      const date = new Date(card.dataset.deadline + 'T12:00:00');
      const display = new Intl.DateTimeFormat('en-GB',{day:'2-digit',month:'short',year:'numeric'}).format(date).toUpperCase();
      const title = card.querySelector('h3')?.textContent?.trim() || '';
      const cats = (card.dataset.categories || '').split('|').filter(Boolean).slice(0,2).join(' / ');
      return '<div class="chr-oc-board-row"><span>'+display+'</span><b>'+escapeHtml(card.dataset.city+' / '+card.dataset.country)+'</b><b>'+escapeHtml(title)+'</b><span>'+escapeHtml(cats || card.dataset.format)+'</span><a href="#'+escapeHtml(card.id)+'" data-oc-jump>OPEN</a></div>';
    }).join('');

    const boardRows = [...board.querySelectorAll('.chr-oc-board-row')];
    boardRows.forEach((row,rowIndex) => {
      row.style.setProperty('--oc-row-delay', (rowIndex * 190) + 'ms');
      [...row.children].forEach((cell,cellIndex) => {
        cell.style.setProperty('--oc-cell-delay', (cellIndex * 58) + 'ms');
      });
    });
    requestAnimationFrame(() => boardRows.forEach(row => row.classList.add('is-flipping')));

    board.querySelectorAll('[data-oc-jump]').forEach(link => {
      link.addEventListener('click', event => {
        const target = root.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        reset();
        target.scrollIntoView({behavior:'smooth',block:'start'});
        window.setTimeout(() => target.focus({preventScroll:true}), 450);
      });
    });
  }

  const syncToTop = () => {
    if (!toTop) return;
    toTop.classList.toggle('is-visible', root.getBoundingClientRect().top < -700);
  };
  syncToTop();
  window.addEventListener('scroll', syncToTop, {passive:true});
  toTop?.addEventListener('click', () => window.scrollTo({top:0,behavior:'smooth'}));

  root.querySelectorAll('[data-oc-calendar]').forEach(calendar => {
    const card = calendar.closest('[data-oc-call]');
    if (!card) return;
    const start = compactDate(card.dataset.deadline);
    const end = nextDate(card.dataset.deadline);
    const title = card.dataset.calTitle || 'Open Call Deadline';
    const location = card.dataset.calLocation || '';
    const description = card.dataset.calDescription || '';
    const google = 'https://calendar.google.com/calendar/render?action=TEMPLATE&text=' + encodeURIComponent(title) + '&dates=' + start + '/' + end + '&details=' + encodeURIComponent(description) + '&location=' + encodeURIComponent(location);
    const googleLink = calendar.querySelector('[data-oc-cal-google]');
    if (googleLink) { googleLink.href = google; googleLink.target = '_blank'; googleLink.rel = 'noopener'; }
    const ics = ['BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//Chromatica//Open Call Radar//EN','BEGIN:VEVENT','DTSTART;VALUE=DATE:' + start,'DTEND;VALUE=DATE:' + end,'SUMMARY:' + title.replaceAll(',', '\\,'),'LOCATION:' + location.replaceAll(',', '\\,'),'DESCRIPTION:' + description.replaceAll('\n',' ').replaceAll(',', '\\,'),'END:VEVENT','END:VCALENDAR'].join('\r\n');
    const icsLink = calendar.querySelector('[data-oc-cal-ics]');
    if (icsLink) { icsLink.href = 'data:text/calendar;charset=utf-8,' + encodeURIComponent(ics); icsLink.download = 'chromatica-open-call-deadline.ics'; }
  });

  const clock = root.querySelector('[data-oc-clock]');
  const tick = () => {
    if (!clock) return;
    const parts = new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Berlin',hour:'2-digit',minute:'2-digit',hour12:false}).format(new Date());
    clock.textContent = parts + ' / BERLIN';
  };
  tick();
  setInterval(tick,60000);

  const shopCards = [...root.querySelectorAll('[data-oc-product]')];
  const shuffleProducts = () => {
    const pool = [...shopCards].sort(() => Math.random() - .5);
    shopCards.forEach(card => card.classList.remove('is-visible'));
    pool.slice(0,3).forEach(card => card.classList.add('is-visible'));
  };
  root.querySelector('[data-oc-shuffle]')?.addEventListener('click', shuffleProducts);
  if (shopCards.length > 3) shuffleProducts();

  function escapeHtml(value){
    return String(value || '').replace(/[&<>"']/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]));
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chromatica-product-tester"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-pt-root]').forEach((root) => {
    const links = [...root.querySelectorAll('[data-pt-route]')];
    const sections = [...root.querySelectorAll('[data-pt-section]')];

    if ('IntersectionObserver' in window && links.length && sections.length) {
      const map = new Map(links.map((a) => [a.getAttribute('data-pt-route'), a]));
      const observer = new IntersectionObserver((entries) => {
        const hit = entries.filter((e) => e.isIntersecting).sort((a,b) => b.intersectionRatio-a.intersectionRatio)[0];
        if (!hit) return;
        links.forEach((a) => a.classList.remove('is-active'));
        const active = map.get(hit.target.id);
        if (active) active.classList.add('is-active');
      }, {rootMargin:'-24% 0px -60% 0px',threshold:[.02,.15,.4]});
      sections.forEach((s) => observer.observe(s));
    }

    const applicationEmail = root.querySelector('[data-pt-application-email]');
    const newsletterEmail = root.querySelector('[data-pt-newsletter-email]');
    if (applicationEmail && newsletterEmail) {
      applicationEmail.addEventListener('input', () => {
        if (!newsletterEmail.dataset.edited) newsletterEmail.value = applicationEmail.value;
      });
      newsletterEmail.addEventListener('input', () => {
        newsletterEmail.dataset.edited = '1';
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chromatica-urban-weekly-field-report"]) return;
  try {
    
function initUrbanWeeklyFieldReport(root){
  const list=root.querySelector('[data-uwf-toc]');
  const stories=[...root.querySelectorAll('.uw-story[id]')];
  if(!list||!stories.length)return;
  list.innerHTML='';
  const links=[];
  stories.forEach((story,index)=>{
    const type=story.querySelector('.uw-story__rail small')?.textContent?.trim()||'SIGNAL';
    const headline=story.querySelector('h2')?.textContent?.trim()||type;
    const li=document.createElement('li');
    const a=document.createElement('a');
    a.href='#'+story.id;
    a.innerHTML='<b>'+String(index+1).padStart(2,'0')+'</b><span>'+type+' / '+headline+'</span>';
    li.appendChild(a);list.appendChild(li);links.push(a);
  });
  if('IntersectionObserver'in window){
    const observer=new IntersectionObserver((entries)=>{entries.forEach((entry)=>{if(entry.isIntersecting){links.forEach((link)=>link.classList.toggle('is-active',link.getAttribute('href')==='#'+entry.target.id));}});},{rootMargin:'-28% 0px -58% 0px',threshold:.01});
    stories.forEach((story)=>observer.observe(story));
  }
}
document.querySelectorAll('[data-uwf]').forEach(initUrbanWeeklyFieldReport);
document.addEventListener('shopify:section:load',(event)=>{const root=event.target.querySelector?.('[data-uwf]')||event.target.closest?.('[data-uwf]');if(root)initUrbanWeeklyFieldReport(root);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
